
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapState } from 'vuex';
    import { LagerlisteJeCharge as LagerlisteJeChargeType } from '@/store/types';
    import { LagerlisteFilter } from '@/store/lagerfuehrung';

    @Component({
        computed: {
            ...mapState('authentication', ['user']),
            ...mapGetters('authentication', ['impfstelleDetail']),
            ...mapState('lagerfuehrung', ['loaders', 'lagerlisteJeCharge']),
        },
        methods: {
            ...mapActions('lagerfuehrung', [
                'loadLagerlisteJeCharge',
                'printLagerlisteJeCharge',
                'exportLagerlisteJeCharge',
            ]),
        },
    })
    export default class LagerlisteJeCharge extends Vue {
        @Prop() visible!: boolean;
        @Prop({ default: () => ({ gueltig: 'j' })}) mainFilter!: LagerlisteFilter;

        public lagerlisteJeCharge!: LagerlisteJeChargeType[];

        public filter: LagerlisteFilter = {
            verfuegbar: true,
            alleImpfstellen: false,
        };

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.filter.verfuegbar = true;
                this.filter.alleImpfstellen = false;
            }
        }
    }
